import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PrivacyPolicyComponent } from '@mic-ac/ui-kit';

@Component({
  selector: 'app-privacy-policy-page',
  standalone: true,
  imports: [PrivacyPolicyComponent],
  template: `<app-privacy-policy />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPolicyPageComponent {}
